import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const BASE_URL = process.env.API_URL + '/admin'

const SubmissionService = {
  actions: {
    fetchAllSubmissions ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/submissions',
          method: 'GET'
        })
          .then(resp => {
            const submissions = resp.data.submissions
            commit('api_success')
            resolve(resp)
            return submissions
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    deleteSubmission ({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/submission/' + id,
          method: 'delete'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    },
    updateSubmissionStatus ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/submission/' + data.id,
          data: data,
          method: 'PATCH'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    }
  }
}

export default SubmissionService



// WEBPACK FOOTER //
// ./src/services/submissionService.js